import {
  FeatureName,
  PermissionValues as Permissions,
  WorkspaceType,
} from '@gripp/shared-logic';
import { HomeDashboardPage } from './components/homeDashboardPage';

export const homeDashboardPaths = {
  root: 'home',
} as const;

export const homeDashboardRoutes = [
  {
    path: `${homeDashboardPaths.root}/*`,
    element: <HomeDashboardPage />,
    handle: {
      header: {
        titleKey: 'home.page.title',
        icon: 'map',
      },
      // ProtectedRoute only enforces `requiredPermission`; the feature flag and
      // workspace-type are enforced page-side by HomeDashboardPage's self-guard
      // (see component). `requiredFeature` / `requiredWorkspaceType` are carried
      // here for parity with the menu entry + future centralized gating.
      requiredPermission: Permissions.activity.read,
      requiredWorkspaceType: WorkspaceType.Oem,
      requiredFeature: FeatureName.OemHomeDashboard,
    },
  },
];
